module.exports = __webpack_public_path__ + "img/sponsor-carousel-coastal.fa91e778.jpg";